import app from 'app';

function ChIconCtrl ($element, chIconService) {

  /**
   * Update the icon element.
   *
   * @param  {string} iconName - latest binding name
   */
  function updateDlsIcon (iconName) {
    const dlsIconName = chIconService.getDlsIconName(iconName);
    if (dlsIconName) {
      $element.html(`<${dlsIconName}></${dlsIconName}>`);
    }
  }

  /**
   * Update the icon element when binding changes.
   *
   * @param  {object} changes - Changes object passed in by Angular.
   */
  this.$onChanges = changes => {
    const {name: {currentValue: iconName}} = changes;
    updateDlsIcon(iconName);
  };
}

app.component('chIcon', {
  bindings: {
    name: '@'
  },
  controller: ChIconCtrl
});



// WEBPACK FOOTER //
// ./components/chIcon.js